import UserActivityLog from './component'

export default UserActivityLog